'use strict';

function SystemStatusInterfaceStatusController($scope, systemStatusCommonRendererFactory) {
  $scope.gridId = 'system-status-interface-status';
  $scope.mode = 'system-status-interface-status-mode';
  $scope.screen = 'SYSTEM_STATUS_SCREEN';
  $scope.customRenderers = systemStatusCommonRendererFactory;
}
SystemStatusInterfaceStatusController.$inject = ['$scope', 'SystemStatusCommonRendererFactory'];
module.exports = SystemStatusInterfaceStatusController;